import PropTypes from 'prop-types';
import BonusIndicatorImpl from './bonus-indicator.js';
import MojitoCore from 'mojito/core';
import BonusIndicatorTypes from './types.js';

/**
 * Bonus indicator component. Displays a clickable label which opens a popup dialog when clicked.
 * Popup can contain additional information about the bonus, such as rules or conditions.
 *
 * @class BonusIndicator
 * @memberof Mojito.Modules
 */

/**
 * Bonus Indicator prop types.
 *
 * @property {string} [bonusType] - The {@link Mojito.Modules.BonusIndicator.types.TYPES|type} of the bonus indicator which determines the icon, labels, etc.
 * @property {string} [title = ''] - Title to show in the component label. If not provided the default translation for particular bonus type will be used.
 * @property {string} [text = ''] - Text to show in the tooltip. If not provided the default translation for particular bonus type will be used.
 * @property {object} [bonusInfo] - Additional information about the bonus. The structure of this object may vary depending on the bonus type.
 * @property {string} [currencyCode] - Currency code used for formatting monetary values in the tooltip text.
 * @property {boolean} [isAwarded = false] - Flag indicating whether the bonus has been awarded.
 * @property {string} [class = ''] - Class name applied to the component's outermost container.
 * @property {boolean} [disabled = false] - Flag indicating whether the component is clickable and can present the tooltip popover.
 * @memberof Mojito.Modules.BonusIndicator
 */
const propTypes = {
    bonusType: PropTypes.oneOf(Object.values(BonusIndicatorTypes.TYPES)).isRequired,
    bonusInfo: PropTypes.object,
    currencyCode: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    isAwarded: PropTypes.bool,
    class: PropTypes.string,
    disabled: PropTypes.bool,
};

const defaultProps = {
    title: '',
    text: '',
    isAwarded: false,
    disabled: false,
    class: '',
};

export default MojitoCore.Presentation.UIView(
    'BonusIndicator',
    BonusIndicatorImpl,
    propTypes,
    defaultProps
);
